import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { Card, CardContent } from "@/components/ui/card";
import { Loader2, FileText, ArrowRight } from "lucide-react";
import axios from "axios";
import API from "@/apiConfig";

export default function FormsPage() {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/forms`)
      .then((r) => setForms(Array.isArray(r.data) ? r.data : []))
      .catch(() => setForms([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <div className="bg-navy text-white py-16 sm:py-20 text-center" data-testid="forms-directory">
        <div className="container-page">
          <div className="w-10 h-[3px] bg-gold mx-auto mb-6" />
          <h1 className="font-heading text-4xl sm:text-5xl text-white mb-3">Forms</h1>
          <p className="text-bone/60 text-sm sm:text-base max-w-lg mx-auto">
            Sign up, register, and connect with Word Alive Global Center
          </p>
        </div>
      </div>

      <div className="container-page py-12 sm:py-16">
        {loading ? (
          <div className="flex justify-center py-16">
            <Loader2 className="h-8 w-8 animate-spin text-gold" />
          </div>
        ) : forms.length === 0 ? (
          <div className="text-center py-16" data-testid="forms-empty-state">
            <FileText className="h-12 w-12 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500 text-lg font-heading">No forms available right now</p>
            <p className="text-gray-400 text-sm mt-2">Check back soon for new opportunities to connect.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {forms.map((form) => (
              <Link key={form.slug} to={`/forms/${form.slug}`} data-testid={`form-card-${form.slug}`}>
                <Card className="border-t-2 border-gold hover:shadow-lg transition-all duration-300 hover:-translate-y-1 h-full">
                  <CardContent className="p-6">
                    <FileText className="h-8 w-8 text-gold mb-3" />
                    <h3 className="font-heading text-lg text-navy mb-2">{form.title}</h3>
                    {form.description && (
                      <p className="text-gray-500 text-sm line-clamp-2 mb-4">{form.description}</p>
                    )}
                    <span className="inline-flex items-center gap-1 text-gold text-sm font-semibold">
                      Fill Out <ArrowRight className="h-4 w-4" />
                    </span>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
